export default (x = 0, y = 0, range = 1) =>
  x === y || Math.abs(x - y) <= range || Math.abs(y - x) <= range
